import React, { useEffect } from 'react';
import { MainTable } from '../../../Components/Macro/MainTable/MainTable';
import { useNashr } from './State';
import Add from './Add';
import Edit from './Edit';

function Nashr() {
    let  { columns, nashrs, getNashr, setEd, deleteNashr } = useNashr()

    useEffect(() => {
        getNashr()
    }, [])
    return (
        <MainTable 
            pageTitle={'Nashriyotlar'}
            pcolumns={columns}
            pdata={nashrs}
            defkey={'id'}
            add={<Add />}
            edit={<Edit />}
            onEdit={(data) => {
                setEd(data)
            }}
            setEd={setEd}
            onDelete={deleteNashr}
        />
    );
}

export default Nashr;